// extracted by mini-css-extract-plugin
export var fileExt = "_vt-8";
export var fileIcon = "_vt-6";
export var fileLink = "_vt-5";
export var fileName = "_vt-7";
export var image = "_vt-1";
export var imageError = "_vt-3";
export var imageErrorIcon = "_vt-4";
export var imageLink = "_vt-0";
export var imageLoaded = "_vt-2";